import { render } from "./DeliveryPage.vue?vue&type=template&id=296c5e8a"
import script from "./DeliveryPage.vue?vue&type=script&lang=js"
export * from "./DeliveryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__